var _defs, _rect, _path, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tile",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef3f28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8281a"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 112,
    fill: "url(#tile)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fbf7f2",
    fillRule: "evenodd",
    d: "M150 118            h140            a86 86 0 0 1 0 172            h-78            v104            h-62            Z            M212 178            v52            h74            a26 26 0 0 0 0 -52            Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 404,
    cy: 108,
    r: 22,
    fill: "#fbf7f2",
    opacity: 0.92
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 404,
    cy: 108,
    r: 9,
    fill: "#c8281a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.284fec1c744c7d4c0c65709aebfcbcfd.svg";
export { ForwardRef as ReactComponent };